$(() => {
    makeTablesResponsive($('body'));
});

export function makeTablesResponsive(scope: JQuery<HTMLElement>) {
    const tables = scope.find('.datatable');

    tables.each((i, element) => {
        const table = $(element);
        const headings = table.find('thead th, thead td');
        const headingLabels = headings.map((idx, e) => $(e).text());
        const rows = table.find('tbody tr');

        rows.each((idx, e) => {
            const row = $(e);
            const cells = row.find('td');
            const heading = row.find('th').text();

            if (heading) {
                row.attr('data-heading', heading);
            }

            cells.each((index, elem) => {
                const cell = $(elem);
                if (headingLabels[index]) {
                    $(elem).attr('data-heading', headingLabels[index]);
                }
                cell.wrapInner('<div></div>');
            });
        });
    });
}
